import { render, staticRenderFns } from "./UOMForm.vue?vue&type=template&id=1ca3136e&scoped=true"
import script from "./UOMForm.vue?vue&type=script&lang=js"
export * from "./UOMForm.vue?vue&type=script&lang=js"
import style0 from "./UOMForm.vue?vue&type=style&index=0&id=1ca3136e&prod&scoped=true&lang=css"
import style1 from "./UOMForm.vue?vue&type=style&index=1&id=1ca3136e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca3136e",
  null
  
)

export default component.exports